import Vue from "vue";
import axios from "axios";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  actions: {
    index({commit}) {
      return axios.get(process.env.VUE_APP_API_URL + 'extra-settings')
        .then(({data}) => {
            commit('setItems', data)
        });
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
    getBuildObject(state, getters, rootState) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push(option.id);
        }
      });

      return result;
    },

    getPriceObject(state) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push({'name': option.name.nl, 'price': option.price});
        }
      });

      return result;
    },

    getObjectById: (state,getters) => (id) =>  {
      let options = state.all.filter(option => {
        return option.id === id;
      });
      return options !== null ? options[0] : null;
    }
  },

  mutations: {
    setItems(state, array) {
      state.all = array;
    },

    setSelected(state, {index, bool}) {
      state.all[index].selected = bool;
    },

    setSelect(state, array) {
      state.all = array;
    },

    toggleSelected(state, option) {
      Vue.set(option, 'selected', !option.selected);
    },
  },
}
